import { useCallback } from "react";
import { Menu, Stack, Text } from "@mantine/core";
import { useNavigate } from "react-router-dom";
import type { QcNotice } from "../../types/qcReview";

interface Props {
  notices: QcNotice[];
  markRead: (id: string) => Promise<void>;
}
export function QcFailureNoticeItems({ notices, markRead }: Props) {
  const navigate = useNavigate();
  const handleSelect = useCallback(
    (event: React.MouseEvent<HTMLButtonElement>) => {
      const id = event.currentTarget.dataset.noticeId;
      if (id && event.currentTarget.dataset.unread === "true")
        void markRead(id);
      navigate("/pending-work");
    },
    [markRead, navigate]
  );
  return (
    <>
      <Menu.Label>QC failure notices</Menu.Label>
      {notices.length === 0 && (
        <Text size="sm" c="dimmed" p="md">
          No QC failure notices
        </Text>
      )}
      {notices.map((notice) => (
        <Menu.Item
          key={notice.id}
          data-notice-id={notice.id}
          data-unread={!notice.readAt}
          onClick={handleSelect}
        >
          <Stack gap={3}>
            <Text size="sm" fw={notice.readAt ? 500 : 700}>
              Failed QC — {notice.metadata.caseNumber}
            </Text>
            <Text size="xs">{notice.message}</Text>
            <Text size="xs">{notice.readAt ? "Read" : "Unread"}</Text>
          </Stack>
        </Menu.Item>
      ))}
    </>
  );
}
